import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { SaveComment } from '../model/saveComment';
import { APIService } from './api.service';
import { ReturnObject } from '../model/returnobject';
import { CafsComment } from '../model/comment';

@Injectable({
  providedIn: 'root'
})
export class CommentService {

  constructor(private api: APIService) { }

  getComments(assignmentNumber: string): Observable<ReturnObject<CafsComment[]>> {
    return this.api.getAPI(`comments/${assignmentNumber}`);
  }

  addComment(payload: object): Observable<ReturnObject<string>> {
    return this.api.postAPI(`comments`, payload);   
  }

  deleteComment(commentId: number): Observable<ReturnObject<string>> {
    return this.api.deleteByEndpointAPI(`comments`, commentId);
  }

}
